import { memo } from 'react';
import './index.less';
import { useModel, history } from '@umijs/max';

const InfoHouse = () => {
  const { bindInformation } = useModel('useDefaultRoom', (model) => ({
    bindInformation: model.bindInformation,
  }));

  const jumpToAsset = () => {
    history.push('/personAsset');
  };

  return (
    <div className="content" onClick={jumpToAsset}>
      <div className="content-item">
        <div className="name">房产</div>
        <div className="num">{bindInformation?.room || 0}</div>
      </div>
      <div className="content-item">
        <div className="name">车位</div>
        <div className="num">{bindInformation?.park || 0}</div>
      </div>
      <div className="content-item">
        <div className="name">车辆</div>
        <div className="num">{bindInformation?.car || 0}</div>
      </div>
    </div>
  );
};
export default memo(InfoHouse);
